export const GET_PROJECT = {
  REQUEST: 'GET_PROJECT',
  PENDING: 'GET_PROJECT_PENDING',
  FAILED: 'GET_PROJECT_FAILED',
  FULFILLED: 'GET_PROJECT_FULFILLED'
}

export const TRANSFER_PROJECT = 'TRANSFER_PROJECT'
export const DELETE_PROJECT = 'DELETE_PROJECT'